import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDOrders_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDOrders_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetMyDetail: any[];
  GetMyDetail_dummy: any[];
  SelectSTDOrders: any[];
  SelectSTDOrders_dummy: any[];
  SelectStdboxesForBoxid: any[];
  SelectStdboxesForBoxid_dummy: any[];
  GetAllCustomers: any[];
  GetAllCustomers_dummy: any[];
  GetStationsByCustomerId: any[];
  GetStationsByCustomerId_dummy: any[];
  GetKLTBoxByStationId: any[];
  GetKLTBoxByStationId_dummy: any[];
  GetSapInfos: any[];
  GetSapInfos_dummy: any[];
  GetOrdersWithFirstStatus: any[];
  GetOrdersWithFirstStatus_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetUsersWithCustomers: any[];
  GetUsersWithCustomers_dummy: any[];
  OrderBoxCheck: any[];
  OrderBoxCheck_dummy: any[];
  OrderWaitingBoxCheck: any[];
  OrderWaitingBoxCheck_dummy: any[];
  STDOrdersTaslakSave: number;
  STDOrdersTaslakSave_dummy: number;
  ChangeEnabledOf: any;
  ChangeEnabledOf_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  DeleteStdOrdersTaslakWithId: number;
  DeleteStdOrdersTaslakWithId_dummy: number;
  NewFunctionName: number;
  NewFunctionName_dummy: number;
  CreateLogsForUser: string;
  CreateLogsForUser_dummy: string;
  TaslaktToOrders: number;
  TaslaktToOrders_dummy: number;
  DeleteTaslakOrdersByUserId: number;
  DeleteTaslakOrdersByUserId_dummy: number;
  GetCustomerUsers: any[];
  GetCustomerUsers_dummy: any[];
  CreateOrdersPerStation: any;
  CreateOrdersPerStation_dummy: any;
  isComp955021Visible: "visible" | "hidden";
  isComp792079Visible: "visible" | "hidden";
  isComp294882Visible: "visible" | "hidden";
  isComp173899Visible: "visible" | "hidden";
  isComp460615Visible: "visible" | "hidden";
  isComp896963Enabled: "enabled" | "disabled";
}

export class STDOrders_Form_ScreenBase extends React.PureComponent<
  ISTDOrders_Form_ScreenProps,
  any
> {
  stdorders_form_896963_value_kuikaAutoCompleteRef: React.RefObject<any>;
  stdorders_form_717730_value_kuikaAutoCompleteRef: React.RefObject<any>;
  stdorders_form_893443_value_kuikaAutoCompleteRef: React.RefObject<any>;
  stdorders_form_939329_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "7b95507d-512c-482d-b90c-463e63ce753d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 293125, PropertyName: "value", Value: "Sipariş Oluştur" },
        { Id: 523892, PropertyName: "value", Value: "Firma Adı" },
        { Id: 896963, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 317914, PropertyName: "value", Value: "İstasyon Adı" },
        { Id: 717730, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 276188, PropertyName: "value", Value: "KLT Kutusu" },
        { Id: 893443, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 9544, PropertyName: "label", Value: "Ekle" },
        { Id: 326677, PropertyName: "title", Value: "Kutu ID" },
        {
          Id: 327622,
          PropertyName: "value",
          Value: "[datafield:boxidentifier]",
        },
        { Id: 810964, PropertyName: "title", Value: "Ürün Adı" },
        { Id: 678645, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 176808, PropertyName: "title", Value: "Sipariş Durumu" },
        { Id: 294882, PropertyName: "value", Value: "Bekliyor" },
        { Id: 173899, PropertyName: "label", Value: "Sipariş Oluştur" },
        { Id: 833290, PropertyName: "label", Value: "Sipariş Oluştur" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdorders_form_896963_value_kuikaAutoCompleteRef = React.createRef();
    this.stdorders_form_717730_value_kuikaAutoCompleteRef = React.createRef();
    this.stdorders_form_893443_value_kuikaAutoCompleteRef = React.createRef();
    this.stdorders_form_939329_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      GetMyDetail: [],
      SelectSTDOrders: [],
      SelectStdboxesForBoxid: [],
      GetAllCustomers: [],
      GetStationsByCustomerId: [],
      GetKLTBoxByStationId: [],
      GetSapInfos: [],
      GetOrdersWithFirstStatus: [],
      SetValueOf: "",
      GetUsersWithCustomers: [],
      OrderBoxCheck: [],
      OrderWaitingBoxCheck: [],
      DeleteStdOrdersTaslakWithId: 0,
      NewFunctionName: 0,
      CreateLogsForUser: "",
      GetCustomerUsers: [],
      CreateOrdersPerStation: "",
      Notify: false,
      isComp955021Visible: "hidden",
      isComp792079Visible: "hidden",
      isComp294882Visible: "hidden",
      isComp173899Visible: "hidden",
      isComp460615Visible: "hidden",
      isComp896963Enabled: "enabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdorders_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDOrders_FormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdorders_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdorders_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDOrders_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDOrders_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDOrders_Form",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDOrders_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderCreate
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDOrders_FormPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDOrders_FormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CustomerId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_896963_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_717730_value",
            "value",
            "GetStationsByCustomerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      userId_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMyDetail = result?.data.getMyDetail;
    stateVars.SelectSTDOrders = result?.data.selectSTDOrders;
    stateVars.SelectStdboxesForBoxid = result?.data.selectStdboxesForBoxid;
    stateVars.GetAllCustomers = result?.data.getAllCustomers;

    formVars.stdorders_form_896963_options = stateVars.GetAllCustomers;
    stateVars.GetStationsByCustomerId = result?.data.getStationsByCustomerId;

    formVars.stdorders_form_717730_options = stateVars.GetStationsByCustomerId;
    stateVars.GetKLTBoxByStationId = result?.data.getKLTBoxByStationId;

    formVars.stdorders_form_893443_options = stateVars.GetKLTBoxByStationId;
    stateVars.GetSapInfos = result?.data.getSapInfos;
    stateVars.GetOrdersWithFirstStatus = result?.data.getOrdersWithFirstStatus;

    stateVars.isComp460615Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithFirstStatus !== undefined
            ? stateVars.GetOrdersWithFirstStatus?.length > 0
              ? stateVars.GetOrdersWithFirstStatus[0].id
              : null
            : this.state.GetOrdersWithFirstStatus?.length > 0
            ? this.state.GetOrdersWithFirstStatus[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_896963 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    stateVars.dataSource_896963 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;

    stateVars.dataSource_717730 =
      stateVars.GetStationsByCustomerId ?? this.state.GetStationsByCustomerId;
    stateVars.dataSource_717730 =
      stateVars.GetStationsByCustomerId ?? this.state.GetStationsByCustomerId;
    formVars.stdorders_form_792079_hoverText = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationsByCustomerId !== undefined
        ? stateVars.GetStationsByCustomerId?.length > 0
          ? stateVars.GetStationsByCustomerId[0].stationAddress
          : null
        : this.state.GetStationsByCustomerId?.length > 0
        ? this.state.GetStationsByCustomerId[0].stationAddress
        : null
    );

    stateVars.isComp792079Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_717730_value",
            "value",
            "GetStationsByCustomerId",
            "id",
            "stationName"
          )
        ),
        ""
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_893443 =
      stateVars.GetKLTBoxByStationId ?? this.state.GetKLTBoxByStationId;
    stateVars.dataSource_893443 =
      stateVars.GetKLTBoxByStationId ?? this.state.GetKLTBoxByStationId;

    stateVars.dataSource_939329 =
      stateVars.GetOrdersWithFirstStatus ?? this.state.GetOrdersWithFirstStatus;

    stateVars.isComp294882Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdorders_form_939329_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp460615Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithFirstStatus !== undefined
            ? stateVars.GetOrdersWithFirstStatus?.length > 0
              ? stateVars.GetOrdersWithFirstStatus[0].id
              : null
            : this.state.GetOrdersWithFirstStatus?.length > 0
            ? this.state.GetOrdersWithFirstStatus[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDOrders_FormComponent_666162_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_896963_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_896963_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_896963_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationsByCustomerId = result?.data.getStationsByCustomerId;

    formVars.stdorders_form_717730_options = stateVars.GetStationsByCustomerId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormComponent_896963_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_896963_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stdorders_form_893443_value",
        "string"
      ),
      "",
      null,
      "Id"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormComponent_896963_onChange2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDOrders_FormComponent_896963_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_896963_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_896963_onChange2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUsersWithCustomers = result?.data.getUsersWithCustomers;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormComponent_896963_onChange3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_896963_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_717730 =
      stateVars.GetStationsByCustomerId ?? this.state.GetStationsByCustomerId;
    stateVars.dataSource_717730 =
      stateVars.GetStationsByCustomerId ?? this.state.GetStationsByCustomerId;
    formVars.stdorders_form_792079_hoverText = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationsByCustomerId !== undefined
        ? stateVars.GetStationsByCustomerId?.length > 0
          ? stateVars.GetStationsByCustomerId[0].stationAddress
          : null
        : this.state.GetStationsByCustomerId?.length > 0
        ? this.state.GetStationsByCustomerId[0].stationAddress
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_717730_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_717730_value",
            "value",
            "GetStationsByCustomerId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_717730_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKLTBoxByStationId = result?.data.getKLTBoxByStationId;

    formVars.stdorders_form_893443_options = stateVars.GetKLTBoxByStationId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormComponent_717730_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_717730_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp792079Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_717730_value",
            "value",
            "GetStationsByCustomerId",
            "id",
            "stationName"
          )
        ),
        ""
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_893443 =
      stateVars.GetKLTBoxByStationId ?? this.state.GetKLTBoxByStationId;
    stateVars.dataSource_893443 =
      stateVars.GetKLTBoxByStationId ?? this.state.GetKLTBoxByStationId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_893443_onSelect = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdorders_form_893443_value",
          "value",
          "GetKLTBoxByStationId",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdorders_form_893443_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stdorders_form_893443_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "stdorders_form_893443_value",
          "value",
          "GetKLTBoxByStationId",
          "id",
          "id"
        )
      ),
      null,
      "Id"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdorders_form_893443_value",
          "value",
          "GetKLTBoxByStationId",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdorders_form_893443_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_893443_value",
            "value",
            "GetKLTBoxByStationId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_893443_value",
            "value",
            "GetKLTBoxByStationId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_9544_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.OrderBoxCheck = result?.data.orderBoxCheck;
    stateVars.OrderWaitingBoxCheck = result?.data.orderWaitingBoxCheck;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_9544_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdorders_form_893443_value",
          "value",
          "GetKLTBoxByStationId",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdorders_form_893443_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_893443_value",
            "value",
            "GetKLTBoxByStationId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      CreateDate_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedBy_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      OrderStatus_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      SapOrderId_0: ReactSystemFunctions.convertToTypeByName(55665, "number"),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      userId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_9544_onClick_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDOrdersTaslakSave = result?.data.stdOrdersTaslakSave;
    stateVars.GetOrdersWithFirstStatus = result?.data.getOrdersWithFirstStatus;

    stateVars.isComp460615Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithFirstStatus !== undefined
            ? stateVars.GetOrdersWithFirstStatus?.length > 0
              ? stateVars.GetOrdersWithFirstStatus[0].id
              : null
            : this.state.GetOrdersWithFirstStatus?.length > 0
            ? this.state.GetOrdersWithFirstStatus[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormComponent_9544_onClick_if11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_9544_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName("isComp896963Enabled", "string"),
      ReactSystemFunctions.convertToTypeByName("disabled", "string")
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stdorders_form_717730_value",
        "string"
      ),
      "",
      null,
      "Id"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stdorders_form_893443_value",
        "string"
      ),
      "",
      null,
      "Id"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_9544_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e060e7dd_a6d0_e57d_a58d_363fc9bd49b0_notify",
        this.defaultML,
        "Kutuya ait sipariş mevcut."
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.OrderBoxCheck !== undefined
            ? stateVars.OrderBoxCheck?.length > 0
              ? stateVars.OrderBoxCheck[0].result
              : null
            : this.state.OrderBoxCheck?.length > 0
            ? this.state.OrderBoxCheck[0].result
            : null
        ),
        "0"
      ) &&
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.OrderWaitingBoxCheck !== undefined
            ? stateVars.OrderWaitingBoxCheck?.length > 0
              ? stateVars.OrderWaitingBoxCheck[0].result
              : null
            : this.state.OrderWaitingBoxCheck?.length > 0
            ? this.state.OrderWaitingBoxCheck[0].result
            : null
        ),
        "0"
      )
    ) {
      isErrorOccurred = await this.STDOrders_FormComponent_9544_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.STDOrders_FormComponent_9544_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_277105_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stdorders_form_939329_value", "id"),
        "Guid"
      ),
      userId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_277105_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DeleteStdOrdersTaslakWithId =
      result?.data.deleteStdOrdersTaslakWithId;
    stateVars.GetOrdersWithFirstStatus = result?.data.getOrdersWithFirstStatus;

    stateVars.isComp460615Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithFirstStatus !== undefined
            ? stateVars.GetOrdersWithFirstStatus?.length > 0
              ? stateVars.GetOrdersWithFirstStatus[0].id
              : null
            : this.state.GetOrdersWithFirstStatus?.length > 0
            ? this.state.GetOrdersWithFirstStatus[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormComponent_277105_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_277105_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_939329 =
      stateVars.GetOrdersWithFirstStatus ?? this.state.GetOrdersWithFirstStatus;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_173899_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      userId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "string"
      ),
      sapUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userName
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userName
            : null
        ),
        "string"
      ),
      sapPassword_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userPassword
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userPassword
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_173899_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.NewFunctionName = result?.data.newFunctionName;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormComponent_173899_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_173899_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      createdByUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      logCreatedUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      SapOrderId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.NewFunctionName),
        "number"
      ),
      userId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      userId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_173899_onClick_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CreateLogsForUser = result?.data.createLogsForUser;
    stateVars.TaslaktToOrders = result?.data.taslaktToOrders;
    stateVars.DeleteTaslakOrdersByUserId =
      result?.data.deleteTaslakOrdersByUserId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormComponent_173899_onClick_if11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_173899_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "0316c13e_2b19_cdc9_94f6_a6625b769857_notify",
        this.defaultML,
        "Sipariş kaydı oluşturuldu."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_173899_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "640739eb_1a2a_0d32_ff06_de01c283eaa2_notify",
        this.defaultML,
        "SAP isteğinde hata meydana geldi!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_173899_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(this, this.state.NewFunctionName),
        "0"
      )
    ) {
      isErrorOccurred = await this.STDOrders_FormComponent_173899_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDOrders_FormComponent_173899_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_833290_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      createdByUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      logCreatedUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdorders_form_896963_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      userId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "string"
      ),
      sapUsername_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userName
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userName
            : null
        ),
        "string"
      ),
      sapPassword_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userPassword
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userPassword
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_Form/STDOrders_FormComponent_833290_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CreateLogsForUser = result?.data.createLogsForUser;
    stateVars.GetCustomerUsers = result?.data.getCustomerUsers;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormComponent_833290_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormComponent_833290_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "fb8e3ff1_f7c6_0c0f_f52a_5381b9ccbccb_notify",
        this.defaultML,
        "Sipariş kaydı oluşturuldu."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormComponent_678645_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDOrders_Form"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDOrders_FormPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDOrders_FormPageInit();
    }
  }
}
